import decodeJwt from "jwt-decode";

const guestPages = [
    '#/loginPasswordForgot'
    , '#/loginPasswordReset'
];
function guest() {
    let page = window.location.hash;
    if (page.indexOf('?') > 0) page = page.substring(0, page.indexOf('?'));
    return guestPages.includes(page) ? Promise.resolve('guest') : Promise.reject();
}
export default {
    // called when the user attempts to log in
	login: ({ username, password }) =>  {
        const request = new Request(window.nobid_endpoint+'/users/authenticate', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            // credentials: 'include',
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error("Authentication error. Make sure that your Username and Password match.");
                }
                return response.json();
            })
            .then(({ token, branding, disabled_resources, disabled_features }) => {
              if (token) {
                localStorage.setItem('token', token);
                localStorage.setItem('usr', username);
                if (branding) {
                  localStorage.setItem('nobid_branding', JSON.stringify(branding));
                }
                if (disabled_resources && disabled_resources.length > 0) {
                  localStorage.setItem('nobid_disabled_resources', JSON.stringify(disabled_resources));
                } else {
                  localStorage.removeItem('nobid_disabled_resources');
                }
                if (disabled_features && disabled_features.length > 0) {
                  localStorage.setItem('nobid_disabled_features', JSON.stringify(disabled_features));
                } else {
                  localStorage.removeItem('nobid_disabled_features');
                }
              }
            });
    },
    // called when the user clicks on the logout button
    logout: () => {
    	const token = localStorage.getItem('token');
    	const request = new Request(window.nobid_endpoint+'/users/logout', {
            method: 'GET',
            // credentials: 'include',
            headers: new Headers({ 'Authorization': `Bearer ${token}` }),
        })
        fetch(request);
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('nobid_branding');
        localStorage.removeItem('nobid_disabled_resources');
        localStorage.removeItem('nobid_disabled_features');
        // Reset branding cache so next login fetches fresh
        window.nobid_branding = null;
        window.nobid_branding_loaded = false;
        // Clear tenant cookie
        document.cookie = 'nobid_tenant=;path=/;max-age=0';
        window.redirectHomePage = true;
        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: (error) => {
        // 401 only. 403 used to be treated as "your session is gone" too, which
        // is wrong: 403 means the session is fine and this particular request
        // was refused. The server-side role gates (insights
        // routes/console/advertiser_console_gate.js) answer 403 by design, so a
        // single missing allowlist entry threw the user out to the login screen
        // instead of showing an error - an advertiser pressing Save on the
        // Activity Report or CPM Comparison screen was silently logged out
        // (NBI-45).
        //
        // Resolving here keeps the session and lets react-admin surface the
        // failure through its normal error notification, which reads the
        // top-level `message` the API's sendError mirrors for exactly that
        // purpose (insights routes/api/v1/errors.js).
        if (error.status === 401) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
    	if (error.status === 422) {
    		if (error.body && error.body.message) alert(error.body.message);
    		return Promise.resolve();
    	}
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: ({ status, response }) => {
        return localStorage.getItem('token')
            ? Promise.resolve()
            : guest();
    },
    // called when the user navigates to a new location, to check for permissions / roles
    // getPermissions: () => Promise.resolve(),
    getPermissions: () => {
      const token = localStorage.getItem('token');
      const decodedToken = token ? decodeJwt(token) : {};
      const role = decodedToken.role;
      const resources = decodedToken.resources;
      const preferences = decodedToken.preferences || {};
      const organization_id = decodedToken.organization_id;
      let branding = null;
      try { branding = JSON.parse(localStorage.getItem('nobid_branding')); } catch (e) { /* ignore */ }
      let disabled_resources = [];
      try { disabled_resources = JSON.parse(localStorage.getItem('nobid_disabled_resources')) || []; } catch (e) { /* ignore */ }
      let disabled_features = [];
      try { disabled_features = JSON.parse(localStorage.getItem('nobid_disabled_features')) || []; } catch (e) { /* ignore */ }
      return role && resources ? Promise.resolve({ role, resources, preferences, organization_id, branding, disabled_resources, disabled_features }) : guest();
    }
};
